import { ETourId, type ITourConfig } from '../types';

/**
 * Tour shown when the user first views a published automation details page.
 *
 * Four steps orienting the user around the page:
 * 1. You're here — the Automations sidebar nav item
 * 2. You're looking at a published automation — the details card
 * 3. Track activity over time — the runs insight graph
 * 4. See individual runs — the runs list table
 */
export const viewingPublishedAutomationTour: ITourConfig = {
  id: ETourId.VIEWING_PUBLISHED_AUTOMATION,
  steps: [
    {
      id: 'automation-details-card-highlight',
      fixedPosition: 'bottom-left',
      titleKey: 'tours.viewingPublishedAutomation.detailsCardHighlight.title',
      descriptionKey:
        'tours.viewingPublishedAutomation.detailsCardHighlight.description',
      finishLabelKey:
        'tours.viewingPublishedAutomation.detailsCardHighlight.finishLabel',
      position: 'rightTop',
    },
  ],
  namespace: 'tours',
  variant: 'default',
  size: 'sm',
  analytics: {
    enabled: true,
    eventPrefix: 'tour_viewing_published_automation',
    metadata: {
      tourName: 'Viewing Published Automation',
    },
  },
  persistence: {
    strategy: 'localStorage',
  },
};
